module.exports = __webpack_public_path__ + "img/_box_backup_manager.075d0d3f.svg";